/*jshint esversion: 6 */
// import store from '@/store/index';

function Template(payload) {
  let route = {
    path: payload.path,
    name: payload.name,
    component: () => import(
      /* webpackChunkName: "WorkBench" */ 
    '@/views/WorkBenchRework/WorkBenchWorkPackageEditor.view.vue'),
    props: (route) => {
      return {
        read_only: ['custom', 'company'].includes(route.params.template_type)?false:true,
        create: route.params.workpackage_id === 'create',
        nav_back: payload.nav_back,
        location: payload.location,
        work_package_id: route.params.workpackage_id === 'create'?route.params.workpackage_id:parseInt(route.params.workpackage_id),
        sequence_id: route.params.sequence_id?parseInt(route.params.sequence_id):false,
        waggon_id: route.params.waggon_id?parseInt(route.params.waggon_id):false,
        create_for_project: route.params.create_for_project || false,
        creation_params: route.params.creation_params || false,
      };
    },
    meta: {
      requiresAuth: true
    },
    // beforeEnter: (to, from, next) => {
    //   let prefix = payload.prefix;
    //   console.log(payload.prefix);
    //   if (prefix === 'template_type') {
    //     switch (to.params.template_type) {
    //       case 'custom':
    //       prefix = '';
    //       break;
    //       case 'business':
    //       prefix = 'b';
    //       break;
    //       case 'community':
    //       prefix = 'c';
    //       break;
    //     }
    //   }
    //   console.log(prefix);
    //   store.dispatch('WorkBench/createWBObject', {
    //     url: [
    //       {ai: 'workpackagerecommendations'},
    //     ],
    //     wb_object: payload.create?
    //     {
    //       id: -1,
    //       color: 'red lighten-1',
    //       token: '',
    //       icon: 'obj-drainage-pipe',
    //     }
    //     :
    //     {
    //       id: parseInt(to.params.workpackage_id),
    //       color: store.state.WorkBench[`${prefix}workpackages`][parseInt(to.params.workpackage_id)].color,
    //       token: store.state.WorkBench[`${prefix}workpackages`][parseInt(to.params.workpackage_id)].token,
    //       icon: store.state.WorkBench[`${prefix}workpackages`][parseInt(to.params.workpackage_id)].icon,
    //     }
    //   }).then(() => next());
    // },
  };
  if (payload && payload.children) {
    route.children = payload.children;
  }
  return route;
}
export default Template;
